import { Subject } from 'rxjs'

export enum OnReceivedAction {
    PRINT,
    EXPORT,
}

export enum DataTableEventType {
    OnPrintRequest,
    OnReceivedPrintData,
}
export interface DataTableEventParams {
    targetTableID: string
    type: DataTableEventType
    data: any
    onReceivedAction: OnReceivedAction
    carryOverParams?: any
}

const DataTableEvent = new Subject<DataTableEventParams>()

export default DataTableEvent
